/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './DotLoader.module.scss';

const DotLoader = ({ yellow, dark, small }) => {
  const loaderClass = classNames({
    [styles.loader]: true,
    [styles['loader--yellow']]: yellow,
    [styles['loader--dark']]: dark,
    [styles['loader--small']]: small,
  });

  return <div className={loaderClass} />;
};

DotLoader.propTypes = {
  yellow: PropTypes.bool,
  dark: PropTypes.bool,
  small: PropTypes.bool,
};

export default DotLoader;
